import Vue from 'vue';
import { HTTP } from '../../../../utils/httpCommonUtil';
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner';
import flatPickr from 'vue-flatpickr-component';
import format from 'date-fns/format';
import { UserRoleEnum } from '@/enums/userRolesEnum';
import GenericModal from '@/componentsReusable/genericModal.vue';
import UploadControl from '@/componentsReusable/UploadControl.vue';

export default Vue.component('provider-documents-card', {
  name: 'ProviderDocumentsCard',
  data () {
    let emptyArray: Array<any> = [];

    return {
      cardExpanded: false,
      loadingInitialData: false,
      savingNewProviderDocument: false,
      providerDocuments: emptyArray,
      isAuthorizedToDelete: false,
      showConfirmationModal: false,
      pendingDeleteId: null,
      providerDocument: { "providerId" : this.$route.params.providerId, "isEditing" : true, "isNew" : false }
    }
  },
  components: {
    flatPickr,
    BallPulseLoader,
    VueSimpleSpinner,
    UploadControl,
    GenericModal
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  filters: {
    dateformat (dateISO: string) {
      let tempString: string = format(dateISO, 'M.D.YY - HH:mm');
      return tempString;
    }
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      let iProviderId = this.$route.params.providerId;
      let providerDocument: any = { providerId: iProviderId };
      providerDocument.isEditing = true;
      providerDocument.isNew = false;
      if (this.cardExpanded) {
        this.getProviderDocuments()
      }
    },
    getProviderDocuments () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      let iProviderId = this.$route.params.providerId;
      HTTP.get('/api/providers/' + iProviderId + '/providerDocuments')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Provider Documents.");
        }
        let freshProviderDocuments = response.data.data;
        freshProviderDocuments.forEach( function (providerDocument: any) {
          providerDocument.isEditing = true;
          providerDocument.isNew = false;
          return false;
        });

        self.providerDocuments = freshProviderDocuments;
      })
      .catch(function () {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Provider Documents.'
        });
      })
    },
    addProviderDocument () {
      // Collapse any editing Provider Documents
      // Delete any existing "new" Provider Documents
      let indexesToDelete: any = [];
      this.providerDocuments.forEach(function (providerdoc, index) { 
        if (providerdoc.isNew) {
          indexesToDelete.push(index);
        }
        providerdoc.isEditing = false;
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.providerDocuments.splice(indx,1);
      })

      this.providerDocuments.unshift( 
        {
          "providerId": this.$route.params.providerId,
          "isNew": true,
          "isEditing": true
        }
      );
    },
    associateUploadedFile (s3FilePath: string, providerId: any, fileName: string, providerDocument: any) {
      let self = this
      const entityType = 9; // This is found in the DB. In this case this type means "PROVIDER_DOCUMENT"
      let iProviderId = this.$route.params.providerId;
      HTTP.post('/api/attachment/', {
        "entityId": iProviderId,
        "entityType": entityType,
        "attachmentName": fileName,
        "s3Key": s3FilePath
      })
      .then(function (response) {
        if (!response.data || !response.data.success) {
          throw new Error("Error associating uploaded document.");
        }
        self.getProviderDocuments();
        console.log('Associate document response.success: ' + response.data.success);
        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Successful Document Upload',
          text: 'Document ' + fileName + ' has been successfully uploaded.'
        });
        // providerDocument.attachments.push({
        //   name: fileName,
        //   s3Key: s3FilePath
        // });
      })
      .catch(function (err: any) {
        console.log('response Error!');
        console.log(err);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred saving uploaded document.'
        });
      })
      this.getProviderDocuments()
    },
    openProviderDocument (s3Key: string) {
      // get pre-signed url
      // open pre-signed url in a new tab
      let self = this
      HTTP.get('/api/s3/signed-url/get?s3key=' + s3Key)
      .then(function (response) {
        if (!response.data || !response.data.data) {
          throw new Error("Error getting attachment.");
        }
        console.log('signed URL: ' + response.data.data);
        window.open(response.data.data, '_blank');
      })
      .catch(function (err: any) {
        console.log('response Error!');
        console.log(err);
        // console.log(err.message);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred saving uploaded document.'
        });
      })
    },
    deleteConfirmed (id: any) {
      this.showConfirmationModal = false;
      this.deleteProviderDocument(this.pendingDeleteId, true);
    },
    deleteProviderDocument (id: any, bypassDeleteConfirmation: boolean = false ) {
      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal = true;
        this.pendingDeleteId = id;
        return;
      } else {
        this.pendingDeleteId = null;
      }

      console.log("not returning.");

      let self = this
      HTTP.post('/api/providerDocument/' + id )
      .then(function (response) {
        self.getProviderDocuments();
      })
      .catch(function () {});
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/provider/cards/documents/ProviderDocumentsCard.ts